export function matchSafeSendUrl(messageText) {
  return matchSafeSendV2Url(messageText) || matchSecureSafeSendUrl(messageText);
}

function matchSafeSendV2Url(messageText) {
  const matchResult = messageText.match(
    /.*(https:\/\/([a-zA-Z0-9]*-)?safesendservice.rogers.com\/safesend\/[^"]*)"?/
  );
  return matchResult && matchResult[1];
}

function matchSecureSafeSendUrl(messageText) {
  const matchResult = messageText.match(
    /.*(https:\/\/([a-zA-Z0-9]*-)?chatapps.rogers.com\/secure\/safesend\/[^"]*)"?/
  );
  return matchResult && matchResult[1];
}
